// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx Actions
import { setCustomPDFReportBuilderStore } from '../custom-pdf-report-builder/custom-pdf-report-builder.action';
import { setReportName } from './name.action';
export const name = createReducer('', on(setCustomPDFReportBuilderStore, setReportName, (state, action) => {
    return action.name;
}));
